export const reportAccumulatedDiscountTypes = {
  SET_ACCUMULATED_DISCOUNT_FILTERS: 'SET_ACCUMULATED_DISCOUNT_FILTERS',
  RESTORE_INITIAL: 'REPORT_ACCUMULATED_DISCOUNT/RESTORE_INITIAL'
};
